import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

class RightModal extends Component {
    render() {
        let props = this.props;
        return (
            <div
                className={(props.IsOpen ? 'open ' : '') + 'right-modal'}
                style={{
                    background: props.setting.rightModal.background,
                }}
            >
                <RightModalHeaderLink
                    onClose={props.onClose}
                    item={props.HeadItem}
                />
                <RightModalBody>{props.children}</RightModalBody>
            </div>
        );
    }
}

RightModal.propTypes = {
    IsOpen: PropTypes.bool,
    onClose: PropTypes.func,
    HeadItem: PropTypes.array,
    children: PropTypes.node,
};

class HeaderButton extends Component {
    constructor(props) {
        super(props);
        this.state = {};
        this.toggleHover = this.toggleHover.bind(this);
    }

    toggleHover() {
        this.setState({ hover: !this.state.hover });
    }

    render() {
        const props = this.props;
        return (
            <div
                className="right-modal-header-close"
                onClick={props.onClick}
                onMouseOver={this.toggleHover}
                onMouseOut={this.toggleHover}
                style={{
                    background:
                        props.setting.rightModal.header.button.background,
                    color: props.setting.rightModal.header.button.color,
                    ...(!this.state.hover
                        ? {}
                        : {
                              background:
                                  props.setting.rightModal.header.button
                                      .hoverBackground,
                              color: props.setting.rightModal.header.button
                                  .hoverColor,
                          }),
                }}
            >
                {props.children}
            </div>
        );
    }
}

class RightModalHeader extends Component {
    render() {
        let props = this.props;
        return (
            <div
                className="right-modal-header"
                style={{
                    background: props.setting.rightModal.header.background,
                    color: props.setting.rightModal.header.color,
                }}
            >
                <HeaderButton setting={props.setting} onClick={props.onClose}>
                    <FontAwesomeIcon
                        icon={props.arrow ? 'arrow-right' : 'times'}
                    />
                </HeaderButton>
                {props.back.length && !props.noHistory ? (
                    <HeaderButton
                        setting={props.setting}
                        onClick={props.backEvent}
                    >
                        <FontAwesomeIcon icon="arrow-left" />
                    </HeaderButton>
                ) : null}
                {props.next.length && !props.noHistory ? (
                    <HeaderButton
                        setting={props.setting}
                        onClick={props.nextEvent}
                    >
                        <FontAwesomeIcon icon="arrow-right" />
                    </HeaderButton>
                ) : null}
                {props.item.map((item, key) => {
                    return (
                        <div className="right-modal-header-title" key={key}>
                            {item}
                        </div>
                    );
                })}
            </div>
        );
    }
}

RightModalHeader.propTypes = {
    onClose: PropTypes.func,
    item: PropTypes.array,
};

const mapStateToProps = (state) => {
    return {
        setting: state.appState.setting,
        back: state.rightModalState.cacheOld || [],
        next: state.rightModalState.cacheNext || [],
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        backEvent: () => {
            dispatch({ type: 'backRightModal' });
        },
        nextEvent: () => {
            dispatch({ type: 'nextRightModal' });
        },
    };
};

const RightModalHeaderLink = connect(
    mapStateToProps,
    mapDispatchToProps
)(RightModalHeader);

class RightModalBody extends Component {
    render() {
        let props = this.props;
        return <div className="right-modal-body">{props.children}</div>;
    }
}

RightModalBody.propTypes = {
    children: PropTypes.node,
};

class ExtraModal extends Component {
    render() {
        let props = this.props;
        return (
            <div className={(props.IsOpen ? 'open ' : '') + 'extra-modal'}>
                <RightModalHeaderLink
                    onClose={props.onClose}
                    item={props.HeadItem}
                    noHistory={true}
                />
                <RightModalBody>{props.children}</RightModalBody>
            </div>
        );
    }
}

ExtraModal.propTypes = {
    IsOpen: PropTypes.bool,
    isNoBackground: PropTypes.bool,
    onClose: PropTypes.func,
    HeadItem: PropTypes.array,
    children: PropTypes.node,
};

class RightModalFade extends Component {
    render() {
        let props = this.props;
        return (
            <div
                className={
                    'right-modal-fade' +
                    (props.IsOpen ? ' open' : '') +
                    (props.isNoBackground ? ' bg-none ' : '')
                }
                onClick={props.onClose}
            />
        );
    }
}

RightModalFade.propTypes = {
    IsOpen: PropTypes.bool,
    isNoBackground: PropTypes.bool,
    onClose: PropTypes.func,
};

export { RightModal, ExtraModal, RightModalFade };
